/**
 * Agent configuration operations — list, get, save, delete, schema, models.
 */

import type { ArbiClient, components } from '@arbidocs/client'
import { requireData } from '../errors.js'

type ConfigUpdateData = components['schemas']['ConfigUpdateData']

export async function listConfigs(arbi: ArbiClient) {
  return requireData(
    await arbi.fetch.GET('/v1/configs/versions'),
    'Failed to fetch config versions'
  )
}

export async function getConfig(arbi: ArbiClient, configId: string) {
  return requireData(
    await arbi.fetch.GET('/v1/configs/{config_ext_id}', {
      params: { path: { config_ext_id: configId } },
    }),
    'Failed to fetch configuration'
  )
}

export async function saveConfig(arbi: ArbiClient, body: ConfigUpdateData) {
  return requireData(
    await arbi.fetch.POST('/v1/configs/', { body }),
    'Failed to save configuration'
  )
}

export async function deleteConfig(arbi: ArbiClient, configId: string) {
  return requireData(
    await arbi.fetch.DELETE('/v1/configs/{config_ext_id}', {
      params: { path: { config_ext_id: configId } },
    }),
    'Failed to delete configuration'
  )
}

export async function getSchema(arbi: ArbiClient) {
  return requireData(await arbi.fetch.GET('/v1/configs/schema'), 'Failed to fetch config schema')
}

export async function getModels(arbi: ArbiClient) {
  return requireData(await arbi.fetch.GET('/v1/health/models'), 'Failed to fetch models')
}
